module.exports = __webpack_public_path__ + "01e0bc8f95d479660fc94129bf726341.svg";